import { render } from "./table_page_layout.vue?vue&type=template&id=b6d6f5ee&scoped=true"
import script from "./table_page_layout.vue?vue&type=script&lang=js"
export * from "./table_page_layout.vue?vue&type=script&lang=js"

import "./table_page_layout.vue?vue&type=style&index=0&id=b6d6f5ee&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6d6f5ee"]])

export default __exports__